import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import locationActions from "../../_actions/locationActions";
import feederListActions from "../../_actions/feederListActions";

class AddAlignmentModalV3 extends Component {
  state = {
    alignment_label: "",
    // description: "",
    errors: {
      alignmentExists: false,
    },
  };

  componentDidMount() {
    const { dispatch, projectId } = this.props;
    dispatch(feederListActions.getLocationTypes(projectId));
  }

  handleChange = (e) =>
    this.setState({
      [e.target.name]: e.target.value,
      errors: { ...this.state.errors, alignmentExists: false },
    });

  handleSubmit = (e) => {
    e.preventDefault();
    const { alignment_label } = this.state;
    const {
      dispatch,
      locationTypeList,
      projectId,
      toggleModal_addAlignment,
      updateSelectedAlignment,
    } = this.props;
    const locationType = (locationTypeList || []).find(
      (lt) => lt.description === "Alignment"
    );
    if (!locationType) return;
    dispatch(locationActions.exists(projectId, alignment_label)).then(
      (locationExists) => {
        if (!locationExists) {
          const location = {
            name: alignment_label,
            projectId,
            locationTypeId: locationType.locationTypeId,
            isGeneric: false,
          };
          dispatch(locationActions.add(location)).then((locId) => {
            toggleModal_addAlignment();
            updateSelectedAlignment(locId);
          });
        } else {
          this.setState({ errors: { ...this.state.errors, alignmentExists: true } });
        }
      }
    );
  };

  render() {
    const { alignment_label, errors } = this.state;
    const { showModal_addAlignment, toggleModal_addAlignment, locationTypeList } =
      this.props;
    const closeBtn = (
      <button className="close" onClick={toggleModal_addAlignment}>
        <FontAwesomeIcon icon="times" className="fa-fw text-white" />
      </button>
    );
    return (
      <Modal
        isOpen={showModal_addAlignment}
        toggle={toggleModal_addAlignment}
        className={this.props.className}
        fade={false}
        size={"md"}
      >
        <ModalHeader
          toggle={toggleModal_addAlignment}
          className="bg-info text-white"
          close={closeBtn}
        >
          <FontAwesomeIcon icon="plus" className="fa-fw mr-2" />
          Add New Alignment
        </ModalHeader>
        <ModalBody>
          <div className="card">
            <div className="card-body">
              <div className="form-row form-group mb-0">
                <label htmlFor="name" className="col-3 col-form-label">
                  <b>Line:</b>
                </label>
                <div className="col-9">
                  <input
                    type="input"
                    id="name"
                    name="alignment_label"
                    className="form-control"
                    maxLength="15"
                    value={alignment_label}
                    onChange={this.handleChange}
                  />
                  <span>
                    <small>Line label only, without stations (e.g. A1)</small>
                  </span>
                </div>
              </div>
              {errors.alignmentExists && (
                <div className="alert alert-danger mt-2 mb-0 p-2">
                  <div className="d-flex flex-row">
                    <div className="mr-2">
                      <FontAwesomeIcon icon="exclamation-triangle" />
                    </div>
                    <div>
                      This alignment already exists. Provide a unique name for this
                      alignment.
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </ModalBody>
        <ModalFooter className="bg-lightgray">
          <button
            type="button"
            id="addAlignment"
            name="addAlignment"
            className="btn btn-primary"
            onClick={this.handleSubmit}
            disabled={
              !alignment_label || locationTypeList.length === 0 || errors.alignmentExists
            }
          >
            Add
          </button>{" "}
          <button
            type="button"
            id="cancelAddAlignment"
            name="cancelAddAlignment"
            className="btn btn-secondary"
            onClick={toggleModal_addAlignment}
          >
            Cancel
          </button>
        </ModalFooter>
      </Modal>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  locationTypeList: state.feederLists.locationTypeList || [],
});

export default connect(mapStateToProps)(AddAlignmentModalV3);
